import { useCallback } from 'react'
import { useTranslation } from 'react-i18next'
import { api } from '../api/client'
import { useUserContext } from '../providers/UserContextProvider'

export function useLanguage() {
  const { i18n } = useTranslation()
  const { userDetail } = useUserContext()

  const changeLanguage = useCallback(
    async (lang: string) => {
      await i18n.changeLanguage(lang)
      localStorage.setItem('okr-language', lang)

      if (userDetail?.id) {
        try {
          await api.users.updatePreferences({ language: lang as 'en' | 'nb' })
        } catch {
          // Non-critical: preference sync failure is acceptable
        }
      }
    },
    [i18n, userDetail?.id]
  )

  return {
    language: i18n.language,
    changeLanguage,
  }
}
